import React from "react";

const Modal = ({
  children,
  onClose,
  disableOutsideClick = false,
  widthClass = "sm:w-[700px]",
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* overlay */}
      <div
        className="absolute inset-0 bg-black bg-opacity-60"
        onClick={disableOutsideClick ? undefined : onClose}
      />

      {/* modal content */}
      <div
        className={`relative bg-white w-[95%] ${widthClass} max-h-[90vh] overflow-y-auto rounded-lg shadow-xl p-4 sm:p-6`}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
